import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';

import { FormData } from '@fry/lib/forms';

import { NotifyService } from '@fry/lib/utils';
import { CanComponentDeactivate } from '@fry/components/common/form';
import { BookingTypeEditForm } from '@fry/booking/lib/booking-types/booking-type-edit.form';
import { BookingType } from '@fry/booking/lib';

@Component({
    selector: 'eas-booking-type-edit',
    templateUrl: './booking-type-edit.component.html',
    providers: [
        BookingTypeEditForm
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BookingTypeEditComponent implements OnInit, CanComponentDeactivate {

  public bookingType: BookingType;
  public formData$: Observable<FormData>;

  constructor(
    private editForm: BookingTypeEditForm,
    private route: ActivatedRoute,
    private notify: NotifyService
  ) { }

  ngOnInit() {
    this.route.data.subscribe(
      data => {
        this.bookingType = data.bookingType;
        this.formData$ = this.editForm.init(this.bookingType);
      });
  }

  onSubmit() {
    this.editForm.submit(this.bookingType).subscribe(
      data => {
        this.bookingType = data;
        this.notify.success($localize `Successfully saved`);
      },
      error => this.notify.error(error)
    );
  }

  canSafelyDeactivate() {
    return this.editForm.pristine;
  }

}
